package org.example.zone360.pages.coachDetails.sessionAllDetails.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.minSize
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaPause
import com.varabyte.kobweb.silk.components.icons.fa.FaPlay
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.getSentences
import org.example.zone360.utils.getSessionKeywords
import org.example.zone360.utils.getSingleCoach
import org.example.zone360.utils.getSingleSessions
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomDivider
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.WaveformRangeSlider
import org.example.zone360.components.debugPrintln
import org.example.zone360.components.formatSessionMinutes
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetClubCoachesData
import org.example.zone360.models.GetClubPlayerData
import org.example.zone360.models.GetNamesByIdData
import org.example.zone360.models.GetSentencesData
import org.example.zone360.models.GetSessionKeywordsData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.GetSingleCoachData
import org.example.zone360.pages.coachDetails.sessionAllDetails.AudioWaveform
import org.example.zone360.pages.coachDetails.sessionAllDetails.customHighlight.CustomHighlight
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.example.zone360.utils.SelectedData
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.getCurrentMilliseconds
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.Audio
import org.w3c.dom.HTMLVideoElement

@Composable
fun FullSessionSectionUI(
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    sessionData: GetSessionsData,
    sessionDataCallBack: (GetSessionsData) -> Unit,
    updateCoachInfo: (GetSingleCoachData) -> Unit,
    message: (String) -> Unit,
    sessionType: SelectedData,
    userId: String,
    disable: Boolean,
    isVideoDurationPlaying1: Boolean,
    isVideoDurationPlaying1CallBack: (Boolean) -> Unit,
    isPlayingAll: Boolean,
    isPlayingAllCallBack: (Boolean) -> Unit,
    scope: CoroutineScope,
    fullSessionVideo : Boolean,
    fullSessionVideoCallBack: (Boolean) -> Unit,
    stopPaginationSizeCallBack: (Boolean) -> Unit,
    useOriginalAudio: Boolean,
    useOriginalAudioCallBack: (Boolean) -> Unit,
    currentlyPlayingVideoIdCallBack: (String?) -> Unit,
    currentVideoRef1: MutableState<HTMLVideoElement?>,
    isCustomHighlight : Boolean,
    isCustomHighlightCallBack: (Boolean) -> Unit,
    sliderStartTime: Double,
    sliderStartTimeCallBack: (Double) -> Unit,
    sliderEndTime: Double,
    sliderEndTimeCallBack: (Double) -> Unit,
    seekWhenPaused: Double?,
    seekWhenPausedCallBack: (Double?) -> Unit,
    highlightSegments: List<Pair<Float, Float>>,
    highlightSegmentsCallback: (List<Pair<Float, Float>>) -> Unit,
    fullAudio: Audio?,
    getSentenceAudio: Audio?,
    playAllAudio: Audio?,
    currentAudioRefHighlight1: MutableState<Audio?>,
    playVideoWithAudioFun: ( HTMLVideoElement,Audio?) -> Unit,
    currentVideoTimeCallBack: (Double) -> Unit,
    currentVideoTime: Double,
    isBuffering1 : Boolean,
    videoProgress1: Float,
    videoProgressCallBack: (Float) -> Unit,
    allowProgressUpdateCallBack: (Boolean) -> Unit,
    manualSeekTriggeredCallBack: (Boolean) -> Unit,
    selectedKeyword: String?,
    selectedKeywordCallBack: (String?) -> Unit,
    getSentences: List<GetSentencesData>,
    getSentencesCallBack:(List<GetSentencesData>)-> Unit,
    loadingSessionIdFullSession: String?,
    loadingSessionIdFullSessionCallBack: (String?) -> Unit,
    isAudioDurationPlaying: Boolean,
    isAudioDurationPlayingCallBack: (Boolean) -> Unit,
    currentAudioRefFullSession: MutableState<Audio?>,
    currentlyPlayingIdFullSession: String?,
    currentlyPlayingIdFullSessionCallBack: (String?) -> Unit,
    fullPlayAudioProgress: Float,
    fullPlayAudioProgressCallBack: (Float) -> Unit,
    fullPlaySessionId: String,
    currentlyPlayingIdHighlight: String?,
    currentlyPlayingIdHighlightCallBack: (String?) -> Unit,
    currentKeywordSegmentIndex: Int,
    currentKeywordSegmentIndexCallBack: (Int) -> Unit,
    seekTimeForHighlight : Double?,
    seekTimeForHighlightCallBack: (Double?) -> Unit,
    isPlayingAllSegments: Boolean,
    isPlayingAllSegmentsCallBack: (Boolean) -> Unit,
    showNames: Boolean,
    showNamesCallBack: (Boolean) -> Unit,
    selectedNameCallBack: (String?) -> Unit,
    selectedName : String?,
    currentSentenceIndex: Int,
    currentSentenceIndexCallBack: (Int) -> Unit,
    currentSegmentTime: Pair<String, String>?,
    currentSegmentTimeCallBack: (Pair<String, String>?) -> Unit,
    namesList: List<GetNamesByIdData>,
    sessionKeywords: List<GetSessionKeywordsData>,
    sessionKeywordsCallBack:(List<GetSessionKeywordsData>)-> Unit,
    playAllHide: Boolean,
    playAllHideCallback: (Boolean) -> Unit,
    hasClosedCustomHighlightCallBack: (Boolean) -> Unit,
    isSentenceLoading: Boolean,
    isSentenceLoadingCallBack: (Boolean) -> Unit,
    players: List<GetClubPlayerData>,
    coaches: List<GetClubCoachesData>,
    isAudioLoading : Boolean,
    isAudioLoadingCall: (Boolean) -> Unit,
    playAllJob: Job?,
    playAllJobCallBack: (Job?) -> Unit,
    playAllSentencesSequentially: (sentences: List<GetSentencesData>, videoElement: HTMLVideoElement?, onPlaybackFinished: () -> Unit) -> Unit,
){
    val sessionId1 = sessionData.sessionId
    val isCustomVideo = sessionData.category == "customVideo"
    val sessionDuration = (sessionData.recordTime.toDoubleOrNull() ?: 0.0) / 1000.0
    val currentAudioRefHighlight = remember { mutableStateOf<Audio?>(null) }


    val isInteractionBlocked = isPlayingAll || isCustomHighlight





    Column(
        modifier = Modifier.fillMaxSize()
            .position(Position.Relative)
    )
    {
        SectionTitle("Full Session")

        if (sessionData.videoFile.isNotEmpty()) {
                VideoSectionUI(
                    breakpoint = breakpoint,
                    sitePalette = sitePalette,
                    sessionData = sessionData,
                    isVideoDurationPlaying1 = isVideoDurationPlaying1,
                    isVideoDurationPlaying1CallBack = isVideoDurationPlaying1CallBack,
                    isPlayingAll = isPlayingAll,
                    scope = scope,
                    fullSessionVideoCallBack = fullSessionVideoCallBack,
                    stopPaginationSizeCallBack = stopPaginationSizeCallBack,
                    useOriginalAudio = useOriginalAudio,
                    currentlyPlayingVideoIdCallBack = currentlyPlayingVideoIdCallBack,
                    currentVideoRef1 = currentVideoRef1,
                    isCustomHighlight = isCustomHighlight,
                    sliderStartTime = sliderStartTime,
                    sliderStartTimeCallBack = sliderStartTimeCallBack,
                    sliderEndTime = sliderEndTime,
                    sliderEndTimeCallBack = sliderEndTimeCallBack,
                    seekWhenPaused = seekWhenPaused,
                    seekWhenPausedCallBack = seekWhenPausedCallBack,
                    highlightSegments = highlightSegments,
                    highlightSegmentsCallback = highlightSegmentsCallback,
                    getSentenceAudio = getSentenceAudio,
                    currentAudioRefHighlight1 = currentAudioRefHighlight1,
                    playVideoWithAudioFun = playVideoWithAudioFun,
                    currentVideoTimeCallBack = currentVideoTimeCallBack,
                    currentVideoTime = currentVideoTime,
                    isBuffering1 = isBuffering1,
                    videoProgress1 = videoProgress1,
                    videoProgressCallBack = videoProgressCallBack,
                    allowProgressUpdateCallBack = allowProgressUpdateCallBack,
                    manualSeekTriggeredCallBack = manualSeekTriggeredCallBack,
                    selectedKeyword = selectedKeyword,
                    getSentences = getSentences,
                    selectedName = selectedName,
                    sessionDuration = sessionDuration,
                    currentAudioRefHighlight = currentAudioRefHighlight
                )
        } else {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth()
                        .height(40.px)
                        .borderRadius(8.px)
                        .padding(8.px)
                        .gap(8.px)
                        .backgroundColor(sitePalette.searchBackground.rgb),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    if (loadingSessionIdFullSession == sessionData.sessionId) {
                        Box(
                            modifier = Modifier.width(30.px)
                                .height(28.px)
                                .borderRadius(100.percent)
                                .cursor(Cursor.Pointer)
                                .onClick {
                                    isAudioDurationPlayingCallBack(false)
                                    stopPaginationSizeCallBack(false)

                                    debugPrintln("Pausing loading audio for session: ${sessionData.sessionId}")
                                    currentAudioRefFullSession.value?.pause()
                                    currentlyPlayingIdFullSessionCallBack(null)

                                    currentAudioRefFullSession.value =
                                        null
                                    loadingSessionIdFullSessionCallBack(
                                        null)
                                    fullPlayAudioProgressCallBack(0f)
                                }
                                .backgroundColor(sitePalette.primary.rgb),
                            contentAlignment = Alignment.Center
                        ) {
                            ProgressIndicator(10.px)
                        }
                    } else if (currentlyPlayingIdFullSession == sessionData.sessionId) {
                        Box(
                            modifier = Modifier.width(30.px)
                                .height(28.px)
                                .borderRadius(100.percent)
                                .cursor(Cursor.Pointer)
                                .backgroundColor(sitePalette.primary.rgb)
                                .onClick {
                                    isAudioDurationPlayingCallBack(false)
                                    stopPaginationSizeCallBack(false)

                                    debugPrintln("Pausing audio for session: ${sessionData.sessionId}")
                                    currentAudioRefFullSession.value?.pause()
                                    currentlyPlayingIdFullSessionCallBack(null)
                                    currentAudioRefFullSession.value = null
                                    fullPlayAudioProgressCallBack(0f)

                                },
                            contentAlignment = Alignment.Center
                        ) {
                            FaPause(
                                size = IconSize.XXS,
                                modifier = Modifier.color(Colors.White)
                                    .margin(top = 2.px)
                            )
                        }
                    } else {
                        Box(
                            modifier = Modifier.width(30.px)
                                .height(28.px)
                                .backgroundColor(sitePalette.primary.rgb)
                                .cursor(Cursor.Pointer)
                                .borderRadius(100.percent)
                                .onClick {
                                    if (isPlayingAll) {
                                        message("Full can't be played while playing all highlights.")
                                        showToast(ToastID.ERROR)
                                        return@onClick
                                    }
                                    isAudioDurationPlayingCallBack(true)
                                    stopPaginationSizeCallBack(true)

                                    currentAudioRefFullSession.value?.pause()
                                    loadingSessionIdFullSessionCallBack(fullPlaySessionId)

                                    fullAudio?.onloadeddata = {
                                        loadingSessionIdFullSessionCallBack(null)

                                        // Stop all other audio
                                        playAllAudio?.pause()
                                        getSentenceAudio?.pause()
                                        isPlayingAllCallBack(false)
                                        currentlyPlayingIdHighlightCallBack(null)

                                        if ((selectedKeyword != null || selectedName != null) && highlightSegments.isNotEmpty()) {
                                            // ✅ Keyword/Name playback: let LaunchedEffect handle segment start
                                            val type = if (selectedKeyword != null) "keyword" else "name"
                                            debugPrintln("▶️ $type playback starting at index $currentKeywordSegmentIndex")

                                            // ✅ Set the audio start time to the first highlight segment
                                            val firstSegment = highlightSegments.first()
                                            val startTime = firstSegment.first.toDouble()

                                            fullAudio.currentTime = startTime
                                            currentAudioRefFullSession.value = fullAudio
                                            currentlyPlayingIdFullSessionCallBack(sessionData.sessionId)
                                        } else {
                                            // ✅ Full audio / custom highlight fallback
                                            fullAudio?.currentTime =
                                                0.0
                                            fullAudio?.play()
                                            currentAudioRefFullSession.value =
                                                fullAudio
                                            currentlyPlayingIdFullSessionCallBack(
                                                fullPlaySessionId
                                            )
                                        }
                                    }
                                    fullAudio?.load()
                                },
                            contentAlignment = Alignment.Center
                        ) {
                            FaPlay(
                                size = IconSize.XS,
                                modifier = Modifier.color(Colors.White)
                                    .margin(
                                        top = 1.5.px,
                                        left = 1.5.px
                                    )
                            )
                        }
                    }
                    if (isCustomHighlight) {
                        if (isAudioDurationPlaying) {
                            AudioWaveform(
                                modifier = Modifier.fillMaxWidth(),
                                progress = fullPlayAudioProgress,
                                audioDuration = sessionDuration,
                                isPlaying = true,
                                highlightSegments = listOf(
                                    sliderStartTime.toFloat() to sliderEndTime.toFloat()
                                ), // ✅ KEY LINE
                                currentKeywordSegmentIndex = 0,
                                onClick = { },
                                breakpoint = breakpoint
                            )
                        } else {
                            val initializedWaveform =
                                remember(sessionDuration) {
                                    mutableStateOf(false)
                                }

                            if (!initializedWaveform.value && sliderEndTime == 0.0 && sessionDuration > 0.0) {
                                sliderStartTimeCallBack(0.0)
                                sliderEndTimeCallBack(
                                    sessionDuration.coerceAtMost(
                                        30.0
                                    )
                                )
                                initializedWaveform.value = true
                            }
                            WaveformRangeSlider(
                                initialMinPercent = sliderStartTime / sessionDuration,
                                initialMaxPercent = sliderEndTime / sessionDuration,
                                audioDuration = sessionDuration,
                                sitePalette = sitePalette,
                                onRangeChange = { min, max ->
                                    sliderStartTimeCallBack(
                                        sessionDuration * min
                                    )
                                    sliderEndTimeCallBack(
                                        sessionDuration * max
                                    )
                                }
                            )
                        }
                    } else {
                        AudioWaveform(
                            modifier = Modifier.fillMaxWidth(),
                            progress = fullPlayAudioProgress,
                            audioDuration = (sessionData.recordTime.toDoubleOrNull()
                                ?: 0.0) / 1000.0,
                            highlightSegments = highlightSegments,
                            currentKeywordSegmentIndex = if (selectedKeyword == null && selectedName == null) -1 else currentKeywordSegmentIndex,  // ✅ Update this line
                            onClick = { clickedTimestamp ->
                                // ✅ Correct: No re-randomization, no wave disturbance
                                if (selectedKeyword != null || selectedName != null) return@AudioWaveform
                                seekTimeForHighlightCallBack(clickedTimestamp)

                                val audio =
                                    currentAudioRefFullSession.value
                                if (audio != null) {
                                    audio.currentTime =
                                        clickedTimestamp

                                    if (!audio.paused) {
                                        audio.play().catch {
                                            debugPrintln(" Audio play error after click: ${it.message}")
                                        }
                                    }
                                }
                            },
                            breakpoint = breakpoint,
                            isPlaying = isPlayingAllSegments || (currentlyPlayingIdFullSession == sessionData.sessionId),
                        )
                    }
                }
                if (!isCustomHighlight && !isPlayingAll && selectedKeyword == null && selectedName == null) {
                    val currentTimeInSeconds =
                        (fullPlayAudioProgress * sessionDuration).toLong()
                    val currentTimeFormatted =
                        currentTimeInSeconds.formatSessionMinutes()
                    val totalTimeFormatted =
                        sessionDuration.toLong().formatSessionMinutes()
                    FieldTitleTextNormalSimple(
                        "$currentTimeFormatted / $totalTimeFormatted",
                        width = 100.px, fontSize = 13.px,
                        textAlign = TextAlign.Center
                    )
                }

            }

        }
        Row(
            Modifier.fillMaxWidth()
                .padding(
                    leftRight = 0.px,
                    top = 20.px,
                    bottom = 5.px
                )
                .flexWrap(FlexWrap.Wrap),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        )
        {
            Row(
                modifier = Modifier
                    .margin(topBottom = 10.px)
                    .borderRadius(6.px)
                    .backgroundColor(sitePalette.lightGrey.rgb)
                    .padding(leftRight = 5.px, topBottom = 4.px)
                    .border(1.px, style = LineStyle.Solid, color = Colors.LightGray),
                verticalAlignment = Alignment.CenterVertically
            ) {
                listOf(
                    false to "Keywords",
                    true to "Names"
                ).forEach { (isNames, label) ->
                    val isTabSelected = showNames == isNames
                    Box(
                        modifier = Modifier
                            .borderRadius(4.px)
                            .cursor(Cursor.Pointer)
                            .padding(leftRight = 18.px, topBottom = 6.px)
                            .backgroundColor(if (isTabSelected) Palette.White.rgbLight else Colors.Transparent)
                            .onClick {
                                if (isPlayingAll || isVideoDurationPlaying1 || isAudioDurationPlaying) {
                                    message("Cannot change tabs while playback is active.")
                                    showToast(ToastID.ERROR)
                                    return@onClick
                                }
                                showNamesCallBack(isNames)
                                selectedKeywordCallBack(null)
                                selectedNameCallBack(null)
                                currentKeywordSegmentIndexCallBack(0)
                                currentSentenceIndexCallBack(0)
                            }
                            .boxShadow(
                                offsetX = 0.px,
                                offsetY = if (isTabSelected) 2.px else 0.px,
                                blurRadius = if (isTabSelected) 16.px else 0.px,
                                spreadRadius = null,
                                color = sitePalette.boxShadowColor.rgb
                            ),
                        contentAlignment = Alignment.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            text = label,
                            textAlign = TextAlign.Center,
                            fontWeight = if (isTabSelected) 600 else 500,
                            fontSize = 16.px,
                            isClickable = true,
                            color = if (isTabSelected) sitePalette.primary.rgb else sitePalette.titleColor.rgb
                        )
                    }
                }
            }

            Spacer()

            // Keep existing buttons (Use Audio and Play All)
            if (!isCustomVideo) {
                if (sessionData.videoFile.isNotEmpty()) {
                    CommonButton(
                        text = if (useOriginalAudio) "Use Session Audio" else "Use Original Audio",
                        onCLick = {
                            if (fullSessionVideo || isPlayingAll) return@CommonButton
                            useOriginalAudioCallBack(!useOriginalAudio)
                        },
                        width = 150.px,
                        height = 36.px,
                        pointerCursor = !fullSessionVideo,
                        borderColor = if (fullSessionVideo || isPlayingAll) sitePalette.textFieldBorderColor.rgb else sitePalette.primary.rgb,
                        backgroundColor = Colors.Transparent,
                        textSpanColor = if (fullSessionVideo || isPlayingAll) sitePalette.textFieldBorderColor.rgb else sitePalette.primary.rgb
                    )
                    CustomSpacer(20.px)
                }
            }

            // Play All button
            Row(
                modifier = Modifier
                    .width(120.px)
                    .height(36.px)
                    .borderRadius(4.px)
                    .backgroundColor(sitePalette.searchBackground.rgb)
                    .padding(topBottom = 10.px, leftRight = 10.px)
                    .gap(8.px)
                    .onClick { },
                verticalAlignment = Alignment.CenterVertically
            ) {
                Box(contentAlignment = Alignment.Center) {
                    if (isPlayingAll) {
                        Box(
                            modifier = Modifier
                                .size(27.px)
                                .borderRadius(100.percent)
                                .backgroundColor(sitePalette.primary.rgb)
                                .cursor(Cursor.Pointer)
                                .onClick {
                                    isPlayingAllCallBack(false)
                                    currentVideoTimeCallBack(0.0)
                                    playAllJob?.cancel()
                                    playAllJobCallBack(null)
                                    try {
                                        playAllAudio?.pause()
                                        playAllAudio?.currentTime =
                                            0.0
                                    } catch (e: Exception) {
                                        debugPrintln(" Error pausing audio: ${e.message}")
                                    }
                                    selectedKeywordCallBack(null)
                                    selectedNameCallBack(null)
                                    currentKeywordSegmentIndexCallBack(-1)
                                    isAudioLoadingCall(false)
                                },
                            contentAlignment = Alignment.Center
                        ) {
                            if (isAudioLoading || isBuffering1) {
                                ProgressIndicator(10.px)
                            } else {
                                FaPause(
                                    modifier = Modifier
                                        .color(Palette.White.rgbLight)
                                        .margin(top = 2.px),
                                    size = IconSize.XXS
                                )
                            }
                        }
                    } else {
                        Box(
                            modifier = Modifier
                                .size(24.px)
                                .backgroundColor(if (isCustomHighlight || isVideoDurationPlaying1 || isAudioDurationPlaying || sessionKeywords.isEmpty()) Palette.WaveBarColor.rgbLight else sitePalette.primary.rgb)
                                .cursor(Cursor.Pointer)
                                .borderRadius(100.percent)
                                .onClick {
                                    val videoElement = document.getElementById("video_$sessionId1") as? HTMLVideoElement
                                    if (sessionData.videoFile.isNotEmpty() && (videoElement?.readyState ?: 0) < 1) {
                                        return@onClick
                                    }
                                    if (isCustomHighlight || isVideoDurationPlaying1 || isAudioDurationPlaying || sessionKeywords.isEmpty())
                                        return@onClick

                                    // ✅ Remove or modify this check - only block if no keywords AND no names available
                                    // Show toast if any keyword or name is selected
                                    if (selectedKeyword != null || selectedName != null) {
                                        val type = if (selectedKeyword != null) "keyword" else "name"
                                        message("All highlights can't be played until $type is deselected.")
                                        showToast(ToastID.ERROR)
                                        return@onClick
                                    }

                                    isPlayingAllCallBack(true)
                                    getSentenceAudio?.pause()
                                    fullAudio?.pause()
                                    currentlyPlayingIdFullSessionCallBack(null)
                                    currentlyPlayingIdHighlightCallBack(null)
                                    playAllAudio?.currentTime = 0.0
                                    playAllSentencesSequentially(
                                        getSentences,
                                        document.getElementById("video_$sessionId1") as? HTMLVideoElement,
                                        {
                                            isPlayingAllCallBack(false)
                                            isAudioLoadingCall(false)
                                        }
                                    )
                                },
                            contentAlignment = Alignment.Center
                        ) {
                            FaPlay(
                                modifier = Modifier
                                    .color(Palette.White.rgbLight)
                                    .margin(
                                        left = 2.px
                                    ),
                                size = IconSize.XXS
                            )
                        }
                    }
                }
                FieldTitleTextNormalSimple(
                    "Play All",
                    fontWeight = 500,
                    fontSize = 16.px,
                    fontFamily = Constants.IBM_FONT
                )
            }
        }

        Column(
            modifier = Modifier.fillMaxWidth()
                .minHeight(80.px)
                .maxHeight(450.px)
                .padding(leftRight = 8.px)
                .overflow(
                    overflowY = Overflow.Auto,
                    overflowX = Overflow.Hidden
                )
        ) {

//           Custom Highlight
            Row(
                modifier = Modifier.fillMaxWidth()
                    .margin(top = 10.px)
                    .flexWrap(FlexWrap.Wrap)
                    .overflow(
                        overflowY = Overflow.Auto,
                        overflowX = Overflow.Hidden
                    )
            ) {
                if (showNames) {
                    namesList.forEach { nameItem ->
                        val nameText = nameItem.text.trim()
                        val count = nameItem.usageCount

                        Box(
                            modifier = Modifier.cursor(Cursor.Default)
                                .onClick {
                                    if (isInteractionBlocked) {
                                        val toastMessage = if (isPlayingAll)
                                            "Names can't be selected while playing all highlights."
                                        else if (isCustomHighlight)
                                            "Close custom highlight section to select name."
                                        else
                                            "Interaction blocked."
                                        message(toastMessage)
                                        showToast("toastError")
                                        return@onClick
                                    }

                                    // Simple toggle - same as keywords
                                    selectedNameCallBack(if (selectedName == nameText) null else nameText)
                                    // Reset indices - same as keywords
                                    currentKeywordSegmentIndexCallBack(0)
                                    currentSentenceIndexCallBack(0)

                                }
                        ) {
                            Box(
                                modifier = Modifier.height(32.px)
                                    .backgroundColor(
                                        if (selectedName == nameText) sitePalette.primary.rgb  // ✅ Primary color when selected
                                        else sitePalette.primary.rgb.copyf(alpha = 0.1f)       // ✅ Light color when not selected
                                    )
                                    .borderRadius(7.px)
                                    .padding(
                                        leftRight = 8.px,
                                        topBottom = 4.px
                                    )
                                    .border(
                                        1.px,
                                        color = sitePalette.primary.rgb,
                                        style = LineStyle.Solid
                                    )
                                    .margin(7.px),
                                contentAlignment = Alignment.Center
                            ) {
                                FieldTitleTextNormalSimple(
                                    nameText.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() },
                                    color = if (selectedName == nameText) Colors.White  // ✅ White text when selected
                                    else sitePalette.textFieldTextColor.rgb  // ✅ Dark text when not selected
                                )
                            }
                            Box(
                                modifier = Modifier.minSize(18.px)
                                    .margin(right = (-5).px)
                                    .align(Alignment.TopEnd)
                                    .backgroundColor(
                                        if (selectedName == nameText) sitePalette.primary.rgb  // ✅ Match selected color
                                        else sitePalette.primary.rgb
                                    )
                                    .borderRadius(100.px),
                                contentAlignment = Alignment.Center
                            ) {
                                FieldTitleTextNormalSimple(
                                    text = count.toString(),
                                    color = Colors.White,
                                    fontSize = 10.px
                                )
                            }
                        }
                    }
                } else {
                    sessionKeywords.forEach { keywordItem ->
                        val keyword =
                            keywordItem.text.trim().lowercase()
                        val count = keywordItem.usageCount
                        val keywordCategory =
                            keywordItem.keywordCategory.trim()
                                .lowercase()
                        Box(
                            modifier = Modifier
                                .cursor(if (isInteractionBlocked) Cursor.Default else Cursor.Pointer)
                                .onClick {
                                    if (isInteractionBlocked) {
                                        val toastMessage =
                                            if (isPlayingAll)
                                                "Keywords can't be selected while playing all highlights."
                                            else if (isCustomHighlight)
                                                "Close custom highlight section to select keyword."
                                            else
                                                "Interaction blocked."

                                        message(toastMessage)
                                        showToast("toastError")
                                        return@onClick
                                    }
                                    playAllHideCallback(!playAllHide)
                                    debugPrintln("Play All Hide $playAllHide")
                                    selectedKeywordCallBack(if (selectedKeyword == keyword) null else keyword)
                                    currentKeywordSegmentIndexCallBack(0)
                                    currentSentenceIndexCallBack(0)
                                }
                        ) {
                            Box(
                                modifier = Modifier.height(32.px)
                                    .backgroundColor(
                                        when {
                                            selectedKeyword == keyword -> sitePalette.primary.rgb
                                            else -> when (keywordCategory) {
                                                "fitness" -> sitePalette.fitnessCategoryBackground.rgb
                                                "mental" -> sitePalette.mentalCategoryBackground.rgb
                                                "technical" -> sitePalette.technicalCategoryBackground.rgb
                                                "tactical" -> sitePalette.tacticalCategoryBackground.rgb
                                                "goalkeeper" -> sitePalette.goalKeeperCategoryBackground.rgb
                                                else -> sitePalette.primary.rgb.copyf(
                                                    alpha = 0.1f
                                                )
                                            }
                                        }
                                    )
                                    .borderRadius(7.px)
                                    .padding(
                                        leftRight = 8.px,
                                        topBottom = 4.px
                                    )
                                    .border(
                                        1.px,
                                        color = when {
                                            selectedKeyword == keyword -> sitePalette.primary.rgb.copyf(
                                                alpha = 0.5f
                                            )

                                            else -> when (keywordCategory) {
                                                "fitness" -> sitePalette.fitnessCategoryBorder.rgb
                                                "mental" -> sitePalette.mentalCategoryBorder.rgb
                                                "technical" -> sitePalette.technicalCategoryBorder.rgb
                                                "tactical" -> sitePalette.tacticalCategoryBorder.rgb
                                                "goalkeeper" -> sitePalette.goalKeeperCategoryBorder.rgb
                                                else -> sitePalette.primary.rgb
                                            }
                                        },
                                        style = LineStyle.Solid
                                    )
                                    .margin(7.px),
                                contentAlignment = Alignment.Center
                            ) {
                                FieldTitleTextNormalSimple(
                                    keyword.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() },
                                    color = if (selectedKeyword == keyword) Colors.White else sitePalette.textFieldTextColor.rgb,
                                    isClickable = !isInteractionBlocked
                                )
                            }

                            Box(
                                modifier = Modifier.minSize(18.px)
                                    .margin(right = (-5).px)
                                    .align(Alignment.TopEnd)
                                    .backgroundColor(
                                        when {
                                            selectedKeyword == keyword -> sitePalette.primary.rgb
                                            else -> when (keywordCategory) {
                                                "fitness" -> sitePalette.fitnessCategoryBorder.rgb
                                                "mental" -> sitePalette.mentalCategoryBorder.rgb
                                                "technical" -> sitePalette.technicalCategoryBorder.rgb
                                                "tactical" -> sitePalette.tacticalCategoryBorder.rgb
                                                "goalkeeper" -> sitePalette.goalKeeperCategoryBorder.rgb
                                                else -> sitePalette.primary.rgb
                                            }
                                        }
                                    )
                                    .borderRadius(100.px),
                                contentAlignment = Alignment.Center
                            ) {
                                FieldTitleTextNormalSimple(
                                    text = count.toString(),
                                    color = Colors.White,
                                    fontSize = 10.px
                                )
                            }
                        }
                    }
                }
            }

        }
        if (!isCustomHighlight) {
            CustomDivider()
            CustomSpacer(height = 15.px)
        }
        if (isCustomHighlight) {
            Column(modifier = Modifier.fillMaxWidth()) {
                CustomDivider(modifier = Modifier.margin(topBottom = 15.px))
                SectionTitle("Add Custom Highlight")
                CustomHighlight(
                    breakpoint = breakpoint,
                    sitePalette = sitePalette,
                    sessionData = sessionData,
                    sliderStartTime = sliderStartTime,
                    sliderEndTime = sliderEndTime,
                    seekKey = getCurrentMilliseconds(),
                    onDialogDismiss = {
                        isCustomHighlightCallBack(false)
                        hasClosedCustomHighlightCallBack(true)
                        if (selectedKeyword == null) {
                            highlightSegmentsCallback( getSentences
                                .filter { it.keywords?.isNotEmpty() == true }
                                .map { it.startTime.toFloat() to it.endTime.toFloat() }
                                .sortedBy { it.first }
                            )

                            debugPrintln(" highlightSegments reset after exiting CustomHighlight")
                        }
                    },
                    onSave = {
                        isCustomHighlightCallBack(false)
                        hasClosedCustomHighlightCallBack(true)
                        scope.launch {
                            isCustomHighlightCallBack(false)

                            try {
                                isSentenceLoadingCallBack(true)
                                val refreshed = getSentences(
                                    sessionID = sessionData.sessionId,
                                    type = "sentence",
                                    organization = AppGlobal.userData.organization
                                )
                                getSentencesCallBack(
                                    refreshed.data
                                ) // make .clear and addAll in parent

                                message("Custom highlight added and UI updated.")
                            } catch (e: Exception) {
                                debugPrintln("Error refreshing highlights: ${e.message}")
                            } finally {
                                isSentenceLoadingCallBack(false)
                            }
                            try {
                                val keywordsResponse =
                                    getSessionKeywords(
                                        organization = AppGlobal.userData.organization,
                                        sessionId = sessionData.sessionId,
                                        userID = ""
                                    )
                                sessionKeywordsCallBack(
                                    keywordsResponse.data
                                )

                            } catch (e: Exception) {
                                // Optional: handle error
                            }
                            val response = getSingleSessions(
                                sessionID = sessionData.sessionId,
                                userID = sessionData.userId,
                                domainType = sessionData.domainType,
                                language = sessionData.language,
                                getAll = false,
                                excludeAssessments = false,
                                organization = AppGlobal.userData.organization
                            )
                            sessionDataCallBack(response.data)

                            try {
                                val res = getSingleCoach(
                                    organization = AppGlobal.userData.organization,
                                    domainType = "soccer",
                                    language = "en",
                                    sessionType = sessionType.name,
                                    userID = userId,
                                    seasonID = AppGlobal.selectedSeasonId
                                )
                                updateCoachInfo(res.data)

                            } catch (_: Exception) {
                                debugPrintln("Exception while saving keyword")

                            }
                        }
                    },
                    toastMessageCall = message,
                    sessionDuration = (sessionData.recordTime.toDoubleOrNull()
                        ?: 0.0) / 1000.0,
                    seekTimeFromClick = seekTimeForHighlight,
                    setSeekTimeFromClick = {
                        seekTimeForHighlightCallBack(it)
                    },
                    player = players,
                    coach = coaches,
                    getSentencesList = getSentences,
                    originalAudio = useOriginalAudio,
                    onStartTimeChange = { sliderStartTimeCallBack(it) },
                    onEndTimeChange = { sliderEndTimeCallBack(it) },
                )
                CustomSpacer(height = 20.px)
                CustomDivider(
                    modifier = Modifier.margin(
                        top = 20.px,
                        bottom = 20.px
                    )
                )
            }
        }

        Row(
            modifier = Modifier.fillMaxWidth()
                .flexWrap(FlexWrap.Wrap),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                SectionTitle(
                    if (selectedKeyword == null) "Highlights" else "Individual Highlight",
                    bottom = 0.px,
                    right = 5.px
                )

                val segmentTimeText =
                    currentSegmentTime?.let { (start, end) ->
                        val startSec = start.toDoubleOrNull()
                        val endSec = end.toDoubleOrNull()

                        if (startSec != null && endSec != null) {
                            val startMinutes =
                                (startSec / 60).toInt()
                            val startSeconds =
                                (startSec % 60).toInt().toString()
                                    .padStart(2, '0')

                            val endMinutes = (endSec / 60).toInt()
                            val endSeconds =
                                (endSec % 60).toInt().toString()
                                    .padStart(2, '0')

                            "($startMinutes:$startSeconds - $endMinutes:$endSeconds)"
                        } else {
                            ""
                        }
                    } ?: ""

                if (segmentTimeText.isNotEmpty()) {
                    FieldTitleTextNormalSimple(
                        text = segmentTimeText,
                        fontSize = 14.px,
                        color = sitePalette.infoIconColor.rgb,
                        fontWeight = 600
                    )
                }
            }
            if (!isCustomHighlight && !disable && !showNames) {
                CommonButton(
                    text = "Custom Highlight",
                    icon = { Image(src = Res.Images.custom_Highlight_Icon) },
                    borderColor = sitePalette.mentalCategoryBorder.rgb,
                    textSpanColor = sitePalette.mentalCategoryBorder.rgb,
                    backgroundColor = Colors.Transparent,
                    width = 193.px,
                    height = 38.px,
                    onCLick = {
                        selectedKeywordCallBack(null)
                        isCustomHighlightCallBack(true)
                        isPlayingAllCallBack(false)
                        playAllHideCallback(false)
                    }
                )
            }
        }
 // Highlight section
        HighlightSectionUI(
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            sessionData = sessionData,
            message = message,
            disable = disable,
            isVideoDurationPlaying1 = isVideoDurationPlaying1,
            isPlayingAll = isPlayingAll,
            scope = scope,
            highlightSegments = highlightSegments,
            selectedKeyword = selectedKeyword,
            getSentences = getSentences,
            currentlyPlayingIdFullSession = currentlyPlayingIdFullSession,
            currentlyPlayingIdHighlight = currentlyPlayingIdHighlight,
            currentlyPlayingIdHighlightCallBack = currentlyPlayingIdHighlightCallBack,
            currentKeywordSegmentIndex = currentKeywordSegmentIndex,
            currentKeywordSegmentIndexCallBack = currentKeywordSegmentIndexCallBack,
            showNames = showNames,
            selectedName = selectedName,
            currentSentenceIndex = currentSentenceIndex,
            currentSentenceIndexCallBack = currentSentenceIndexCallBack,
            currentSegmentTimeCallBack = currentSegmentTimeCallBack,
            isSentenceLoading = isSentenceLoading,
            players = players,
            coaches = coaches,

            // shared state
            currentAudioRefHighlight = currentAudioRefHighlight
        )
    }
}